import { Pipe, PipeTransform } from '@angular/core';
import { LoginProvider } from '@interfaces/login-provider.interface';
import { LoginProviderType } from '@enums/enum';

@Pipe({
    name: 'findProviderIdpUrlPipe',
    pure: true,
})
export class FindProviderIdpUrlPipe implements PipeTransform {
    public transform(providers: LoginProvider[], type: LoginProviderType): any {
        let provider: LoginProvider[] = providers.filter((p: LoginProvider) => p.type === type);
        return provider && provider.length ? provider : undefined;
    }
}
